exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#detect-adblock[data-v-cdb15508]{position:absolute;color:transparent;font-size:20px}\n", ""]);

